import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from "../../../../utils/index";
import { ENDPOINTS } from "../../../../constants";
var ActionTypes = {
  FETCH_BALANCE: 'ub/fetch/balance',
  FETCH_BALANCES: 'ub/fetch/balances',
  FETCH_FUB_GROUPS: 'fub/fetch/groups',
  TOGGLE_BALANCE_LIST_MODAL: 'fub/toggle/balance/list/modal',
  MOBILE_CONNECTION_FETCH: 'connection/fetch',
  MOBILE_CONNECTION_PRICE_FETCH: 'connection/price/fetch',
  MOBILE_TARIFF_UP_POWER_FETCH: 'connection/tariffUpPower/fetch',
  MOBILE_TARIFF_UP_SUPERPOWER_FETCH: 'connection/tariffUpSuperPower/fetch',
  FTTB_CONNECTION_FETCH: 'connection/fttb/fetch',
  CONVERGENT_FETCH: 'connection/convergent/fetch'
};
export var ConnectionBlockActionCreator = {
  fetchBalances: createAsyncThunk(ActionTypes.FETCH_BALANCES, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return apiClient.get(ENDPOINTS.fetchBalances);
        case 2:
          result = _context.sent;
          return _context.abrupt("return", result.data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))),
  fetchFubGroups: createAsyncThunk(ActionTypes.FETCH_FUB_GROUPS, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return apiClient.get(ENDPOINTS.fetchFubGroups);
        case 2:
          result = _context2.sent;
          return _context2.abrupt("return", result.data);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))),
  toggleBalanceListModal: createAction(ActionTypes.TOGGLE_BALANCE_LIST_MODAL),
  fetchMobileConnection: createAsyncThunk(ActionTypes.MOBILE_CONNECTION_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionBlock).then(function (res) {
      return res.data;
    });
  }),
  fetchConnectionPrice: createAsyncThunk(ActionTypes.MOBILE_CONNECTION_PRICE_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionPrice).then(function (res) {
      return res.data;
    });
  }),
  fetchConnectionPower: createAsyncThunk(ActionTypes.MOBILE_TARIFF_UP_POWER_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionBlockTariffUpPower).then(function (res) {
      return res.data;
    });
  }),
  fetchConnectionSuperPower: createAsyncThunk(ActionTypes.MOBILE_TARIFF_UP_SUPERPOWER_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionBlockTariffUpSuperPower).then(function (res) {
      return res.data;
    });
  }),
  fetchFTTBConnection: createAsyncThunk(ActionTypes.FTTB_CONNECTION_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return apiClient.get(ENDPOINTS.fttbTariff);
        case 2:
          result = _context3.sent;
          return _context3.abrupt("return", result.data);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }))),
  fetchConvergent: createAsyncThunk(ActionTypes.CONVERGENT_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return apiClient.get(ENDPOINTS.mainHome);
        case 2:
          result = _context4.sent;
          return _context4.abrupt("return", result.data);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })))
};